import { makeStyles } from "@material-ui/core";

import { color, fontFamily } from "../../app/theme";

export const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: fontFamily.Axiforma
  },
  logo: {
    width: "66px",
    [theme.breakpoints.up("sm")]: {
      width: "106px"
    }
  },
  colorOrange: {
    color: color.orange
  },
  saleBanner: {
    fontFamily: "Axiforma, serif, sans-serf !important",
    color: "#fff",
    fontSize: "12px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "18px"
    }
  },
  fontSizeSm: {
    fontSize: "10px !important"
  },
  benefit: {
    color: "#160337",
    fontSize: "20px",
    lineHeight: "1.2",
    fontWeight: 500,
    marginTop: 0,
    marginBottom: 0
  },
  benefitContent: {
    fontSize: "12px",
    color: "#4b5462",
    marginTop: "20px"
  },
  breadcrumb: {
    "& .MuiBreadcrumbs-separator": {
      marginLeft: "0px",
      marginRight: "0px",
      [theme.breakpoints.up("sm")]: {
        marginLeft: "8px",
        marginRight: "8px"
      }
    }
  },
  breadcrumbSeparator: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    color: "#afafaf",
    marginLeft: "0px",
    marginRight: "0px",
    [theme.breakpoints.up("sm")]: {
      marginLeft: "18px",
      marginRight: "18px"
    }
  },
  breadcrumbItem: {
    boxShadow: "none !important",
    fontFamily: fontFamily.Axiforma,
    color: "#afafaf",
    fontWeight: "normal",
    opacity: 1,
    padding: "0 !important",
    margin: "4px 6px 0px",
    borderBottom: "3px solid transparent",
    minWidth: "auto",
    fontSize: "12px",
    minHeight: "auto",
    borderRadius: 0,
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
      margin: "8px 20px 2px",
      minHeight: "auto"
    }
  },
  breadcrumbItemActive: {
    color: "#4b5462 !important",
    fontWeight: "normal",
    borderBottom: "3px solid #f7815c !important"
  },
  timeBox: {
    fontFamily: fontFamily.Axiforma,
    backgroundColor: "#341561",
    borderRadius: "6px",
    minWidth: "30px",
    maxHeight: "29px",
    textAlign: "center",
    padding: "8px 5px 3px 6px",
    [theme.breakpoints.up("sm")]: {
      padding: "8px 11px 6px 12px",
      minWidth: "47px",
      maxHeight: "36px"
    }
  },
  separator: {
    marginLeft: "6px",
    marginRight: "6px"
  },
  timerTitle: {
    fontFamily: fontFamily.Axiforma,
    color: color.purple.dark,
    fontSize: "20px",
    fontWeight: 500,
    marginBottom: "20px"
  },
  timerContent: {
    fontFamily: fontFamily.Axiforma,
    fontSize: "14px",
    fontWeight: 400,
    color: "#4b5462",
    marginBottom: "47px"
  },
  timerButton: {
    "background": color.orange,
    "borderRadius": "27px",
    "boxShadow": "none",
    "&:hover": { background: color.orange, boxShadow: "none" }
  },
  summaryButton: {
    fontFamily: fontFamily.Axiforma,
    height: "48px",
    width: "178px",
    display: "flex",
    alignItems: "center",
    boxShadow: "none",
    padding: "0 8px 0 16px"
  },
  summaryDialog: {
    "& .MuiDialog-paper": {
      width: "100%",
      margin: "18px"
    }
  }
}));
